export const PERCENT_GAIN_FOR_HIGHEST_WRESTLER = 80
export const EXTREME_PERCENT_GAIN_FOR_HIGHEST_WRESTLER = 98
export const SIMULATE_MATCHES_PERIOD = 250
export const SIMULATE_MATCHES_AMOUNT = 50
export const POINTS_STEP = 2
export const ELIMINATION_TICK_TIMER = 100
export const CURRENCY = "$"
export const WEEK_TICK_TIMER = 500
export const SKIP_MATCH_FINE = 1000
export const SKIP_MONTH_FINE = 3500
export const MAX_DAMAGE_PER_MOVE = 8
export const SPEED_PER_MOVE = 300
export const WRESTLER_MAX_POINTS = 200
export const NAME_PLACEHOLDER = "Baron Blade, Brock Lee"



// WEBPACK FOOTER //
// ./src/constants/game.js